module.exports = __webpack_public_path__ + "static/media/delete.ef01c7f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/delete.svg
// module id = 180
// module chunks = 0